export default __webpack_public_path__ + "static/media/downloadCloudBlack.00a1c360.svg";